var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { IconButton as IconButtonBase } from '@mui/material';
import { Tooltip } from 'app/components/Tooltip/Tooltip.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
export function IconButton(_a) {
    var { children, tooltip, disabled, to, square, className, style, buttonRef, icon } = _a, props = __rest(_a, ["children", "tooltip", "disabled", "to", "square", "className", "style", "buttonRef", "icon"]);
    let Button = (_jsxs(IconButtonBase, Object.assign({ disabled: disabled, component: to ? Link : 'button', className: className, to: to, ref: buttonRef, style: square ? Object.assign(Object.assign({}, style), { borderRadius: 0 }) : style }, props, { children: [icon ? _jsx(FontIcon, { icon: icon }) : null, children] })));
    if (tooltip && !disabled) {
        Button = _jsx(Tooltip, { title: tooltip, children: Button });
    }
    return Button;
}
